<div class="customer-feedback">
  <div class="customer-feedback__header">
    <div class="customer-feedback__title">
      Die neusten Kundenbewertungen mit Kommentar
    </div>

    <!-- Sorting Dropdown -->
    <div class="customer-feedback__sorting">
      <label class="sorting-label">Sortieren nach:</label>
      <select
        [(ngModel)]="selectedSorting"
        (change)="onSortingChange()"
        class="sorting-dropdown"
        [disabled]="isLoading"
      >
        <option *ngFor="let option of sortingOptions; trackBy: trackBySortingOption" [value]="option.value">
          {{ option.label }}
        </option>
      </select>
    </div>
  </div>

  <!-- Loading State -->
  <div *ngIf="isLoading" class="customer-feedback__loading">
    <div class="skeleton-box">
      <div class="skeleton-box__row"></div>
      <div class="skeleton-box__row short"></div>
      <div class="skeleton-box__row"></div>
    </div>
  </div>

  <!-- Error State -->
  <div *ngIf="hasError && !isLoading" class="customer-feedback__error">
    <p>Fehler beim Laden der Kundenbewertungen.</p>
  </div>

  <!-- Content -->
  <div
    *ngIf="!isLoading && !hasError && feedbackData"
    class="customer-feedback__content"
  >
    <div *ngFor="let feedback of feedbackItems; trackBy: trackByFeedbackItem" class="feedback-container">
      <div class="feedback-title">
        <div class="feedback-author">
          <app-star-rating
            [rating]="feedback.rating"
            size="medium"
          ></app-star-rating>
          <strong>{{ feedback.authorName }}</strong>
        </div>
        <div class="feedback-date">{{ feedback.date | dateFormat }}</div>
      </div>
      <div class="feedback-text">
        {{ feedback.comment }}
      </div>
    </div>
  </div>
  <div *ngIf="hasNext || hasPrevious" class="feedback-pagination">
    <button
      type="button"
      class="feedback-pagination__previous"
      [disabled]="!hasPrevious || isLoading"
      (click)="previousPage()"
      aria-label="Vorherige Kundenbewertungen"
    >
      « vorherige</button
    ><button
      type="button"
      class="feedback-pagination__next"
      [disabled]="!hasNext || isLoading"
      (click)="nextPage()"
      aria-label="Nächste Kundenbewertungen"
    >
      nächste »
    </button>
  </div>
  <!-- No feedback message -->
  <div *ngIf="feedbackItems.length === 0" class="no-feedback">
    <p>Noch keine Kommentare vorhanden.</p>
  </div>
</div>
